// Pestañas viejas después de publicar: la página pide un pedazo del código (chunk) con un nombre que ya no
// existe en el servidor y el import falla. La salida es recargar UNA vez; una marca en sessionStorage evita
// quedarse recargando en bucle si el problema es otro.
const MARCA = "portal-recarga-por-chunk";
const VENTANA_MS = 5 * 60_000;

const RE_CHUNK =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|unable to preload css|loading (css )?chunk .* failed/i;

export function esErrorDeChunk(e: unknown): boolean {
  const m = e instanceof Error ? e.message : typeof e === "string" ? e : "";
  return RE_CHUNK.test(m);
}

/** Recarga una sola vez (por ventana de 5 min). Devuelve false si ya se intentó y no hay que volver a hacerlo. */
export function recargarPorChunk(): boolean {
  try {
    const antes = Number(sessionStorage.getItem(MARCA) || 0);
    if (antes && Date.now() - antes < VENTANA_MS) return false;
    sessionStorage.setItem(MARCA, String(Date.now()));
  } catch {
    return false; // sin dónde apuntar la marca, no se arriesga un bucle
  }
  const recargar = () => window.location.reload();
  // Sin red, recargar enseñaría la página de «sin conexión» del navegador: se espera a que regrese.
  if (navigator.onLine === false) window.addEventListener("online", recargar, { once: true });
  else recargar();
  return true;
}

/** Engancha el aviso de Vite (`vite:preloadError`) y los imports dinámicos que fallen sin que nadie los atrape. */
export function instalarRecargaPorChunk() {
  window.addEventListener("vite:preloadError", (ev) => {
    if (recargarPorChunk()) ev.preventDefault();
  });
  window.addEventListener("unhandledrejection", (ev) => {
    if (esErrorDeChunk(ev.reason) && recargarPorChunk()) ev.preventDefault();
  });
}
